export default __webpack_public_path__ + "static/media/validation.874c9d0c.svg";